import React from 'react';
import useIntl from '@i18n/useIntl';
import styled from 'styled-components';
import { Link, Text, TextButton, Heading } from '@amzn/storm-ui';
import {
  REGISTRATION_USER_DETAILS_INFO_TRANSLATION_KEY,
  REGISTRATION_USER_DETAILS_LINK_TRANSLATION_KEY,
  REGISTRATION_USER_DETAILS_TITLE_TRANSLATION_KEY,
} from './constants';

const RegistrationFormCardHeaderInfoWrapper = styled.div`
  display: flex;
  p {
    margin-inline-end: ${({ theme }) => theme.spacing.xxsmall.default};
  }
`;

interface RegistrationFormHeaderProps {
  userName: string;
  emailAddress: string;
  switchAccountUrl?: string;
}

const RegistrationUserDetails = ({
  userName,
  emailAddress,
  switchAccountUrl,
}: RegistrationFormHeaderProps) => {
  const { intl } = useIntl();
  return (
    <>
      <Heading renderAs="h2" size="xlarge">
        {`${intl.getMessage(
          REGISTRATION_USER_DETAILS_TITLE_TRANSLATION_KEY,
        )} ${userName}!`}
      </Heading>
      <RegistrationFormCardHeaderInfoWrapper>
        <Text color="secondary">
          {`${intl.getMessage(
            REGISTRATION_USER_DETAILS_INFO_TRANSLATION_KEY,
          )} ${emailAddress}`}
        </Text>
        {switchAccountUrl && (
          <TextButton>
            <Link href={switchAccountUrl}>
              {intl.getMessage(REGISTRATION_USER_DETAILS_LINK_TRANSLATION_KEY)}
            </Link>
          </TextButton>
        )}
      </RegistrationFormCardHeaderInfoWrapper>
    </>
  );
};

export default RegistrationUserDetails;
